export interface FAQItem {
  q: string;
  a: string;
}

const FAQ = ({ items, heading }: { items: FAQItem[]; heading: string }) => (
  <section className="container mx-auto px-6 lg:px-12 max-w-3xl py-16">
    <h2 className="text-3xl font-extrabold tracking-tight mb-8">{heading}</h2>
    <div className="space-y-3">
      {items.map((it) => (
        <details
          key={it.q}
          className="group rounded-xl border border-border bg-background p-4 open:bg-muted/30"
        >
          <summary className="cursor-pointer list-none flex items-center justify-between gap-4">
            <span className="font-semibold text-foreground">{it.q}</span>
            <span className="text-primary group-open:rotate-45 transition-transform text-2xl leading-none">
              +
            </span>
          </summary>
          <p className="mt-3 text-foreground/75 leading-relaxed whitespace-pre-line">{it.a}</p>
        </details>
      ))}
    </div>
  </section>
);

export default FAQ;
